const token = sessionStorage.getItem('token') || ''

//清除缓存（正常退出登录清除，登录设置token清除避免异常退出系统情况）
function clearSession() {
  sessionStorage.removeItem('tab_device')

  sessionStorage.removeItem('battery_chart_time_type')
  sessionStorage.removeItem('battery_chart_time')
  sessionStorage.removeItem('battery_chart_day')
  sessionStorage.removeItem('battery_chart_month')
  sessionStorage.removeItem('battery_chart_year')
  sessionStorage.removeItem('battery_chart_checked')

  sessionStorage.removeItem('charge_chart_time_type')
  sessionStorage.removeItem('charge_chart_time')
  sessionStorage.removeItem('charge_chart_day')
  sessionStorage.removeItem('charge_chart_month')
  sessionStorage.removeItem('charge_chart_year')
  sessionStorage.removeItem('charge_chart_checked')

  sessionStorage.removeItem('collector_chart_time_type')
  sessionStorage.removeItem('collector_chart_time')
  sessionStorage.removeItem('collector_chart_day')
  sessionStorage.removeItem('collector_chart_month')
  sessionStorage.removeItem('collector_chart_year')
  sessionStorage.removeItem('collector_chart_checked')

  sessionStorage.removeItem('inverter_chart_time_type')
  sessionStorage.removeItem('inverter_chart_time')
  sessionStorage.removeItem('inverter_chart_day')
  sessionStorage.removeItem('inverter_chart_month')
  sessionStorage.removeItem('inverter_chart_year')
  sessionStorage.removeItem('inverter_chart_checked')

  sessionStorage.removeItem('solar_chart_time_type')
  sessionStorage.removeItem('solar_chart_time')
  sessionStorage.removeItem('solar_chart_day')
  sessionStorage.removeItem('solar_chart_month')
  sessionStorage.removeItem('solar_chart_year')
  sessionStorage.removeItem('solar_chart_checked')

  sessionStorage.removeItem('switchbox_chart_time_type')
  sessionStorage.removeItem('switchbox_chart_time')
  sessionStorage.removeItem('switchbox_chart_day')
  sessionStorage.removeItem('switchbox_chart_month')
  sessionStorage.removeItem('switchbox_chart_year')
  sessionStorage.removeItem('switchbox_chart_checked')

  sessionStorage.removeItem('v2g_chart_time_type')
  sessionStorage.removeItem('v2g_chart_time')
  sessionStorage.removeItem('v2g_chart_day')
  sessionStorage.removeItem('v2g_chart_month')
  sessionStorage.removeItem('v2g_chart_year')
  sessionStorage.removeItem('v2g_chart_checked')

  sessionStorage.removeItem('tab_device_battery')
  sessionStorage.removeItem('table_device_battery')
  sessionStorage.removeItem('tab_device_charge')
  sessionStorage.removeItem('table_device_charge')
  sessionStorage.removeItem('tab_device_collector')
  sessionStorage.removeItem('table_device_collector')
  sessionStorage.removeItem('tab_device_inverter')
  sessionStorage.removeItem('table_device_inverter')
  sessionStorage.removeItem('tab_device_solar')
  sessionStorage.removeItem('table_device_solar')
  sessionStorage.removeItem('tab_device_switchbox')
  sessionStorage.removeItem('table_device_switchbox')
  sessionStorage.removeItem('tab_device_v2g')
  sessionStorage.removeItem('table_device_v2g')
  sessionStorage.removeItem('tab_station')
  sessionStorage.removeItem('tab_station_table')
  sessionStorage.removeItem('table_station_index')
  sessionStorage.removeItem('tab_station_detail')
  sessionStorage.removeItem('tab_station_detail_device')
  sessionStorage.removeItem('tab_log')
  sessionStorage.removeItem('tab_upgrade')
  sessionStorage.removeItem('tab_base_policies')
  sessionStorage.removeItem('tab_manage_table')
}

//当前登录用户授权变量
export default {
  state: {
    token: token
  },

  mutations: {
    //保存Token
    saveToken(state, value) {
      state.token = value
      sessionStorage.setItem('token', value)
      clearSession()
    },

    //删除Token
    removeToken(state){
      state.token = ''
      sessionStorage.removeItem('token')
      clearSession()
    }
  }
}
